import { FORM_BUNDLE_ACTION_TYPE } from 'store/forms/actions';

const initialState = {};

const formBundleSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FORM_BUNDLE_ACTION_TYPE.GET_BUNDLE_SCHEMA:
      return payload;

    default:
      return state;
  }
};

export default formBundleSchemaReducer;
